import { render, staticRenderFns } from "./certificateMaterialCategory.vue?vue&type=template&id=5d714133&scoped=true"
import script from "./certificateMaterialCategory.vue?vue&type=script&lang=js"
export * from "./certificateMaterialCategory.vue?vue&type=script&lang=js"
import style0 from "./certificateMaterialCategory.vue?vue&type=style&index=0&id=5d714133&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d714133",
  null
  
)

export default component.exports